<template>
    <div class="w-full bg-primary-bg dark:bg-primary-dark-bg rounded-lg border border-light-border dark:border-dark-border overflow-hidden px-6 py-4">
        <button @click="toggleEdit" class="float-right">
            <PencilSquareIcon class="text-indigo-500 hover:text-indigo-600 transition w-6 h-6" />
        </button>

        <div class="flex flex-col items-center my-10">
            <div class="flex-shrink-0 relative group w-32 h-32">
                <img :src="profileImage || defaultImage" alt="Profil Fotoğrafı"
                    class="w-32 h-32 p-2 border rounded-full object-cover shadow-md" />

                <div v-if="isEditing"
                    class="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <label class="cursor-pointer flex flex-col text-center items-center gap-1 text-white text-xs">
                        <CameraIcon class="w-5 h-5" />
                        Fotoğrafı Değiştir
                        <input type="file" @change="imageChange" class="hidden" />
                    </label>
                </div>
            </div>

            <div class="mt-3 text-center">
                <div class="text-xl font-semibold text-primary-text dark:text-gray-100">{{ user.name }} {{ user.surname }}
                </div>
                <div>
                    <span class="text-white bg-red-500 rounded-full px-3 py-1 text-sm mt-1 inline-block">
                        {{ user.role }}
                    </span>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-5">
            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Rol</label>
                <select v-model="user.role" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800">
                    <option value="Admin">Admin</option>
                    <option value="Editor">Editor</option>
                    <option value="User">User</option>
                </select>
            </div>
            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Ad</label>
                <input type="text" v-model="user.name" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Soyad</label>
                <input type="text" v-model="user.surname" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Mail Adresi</label>
                <input type="email" v-model="user.email" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Şifre</label>
                <input type="password" v-model="user.password" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Telefon Numarası</label>
                <input type="tel" v-model="user.phone" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">İl</label>
                <input type="text" v-model="user.city" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">İlçe</label>
                <input type="text" v-model="user.district" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>

            <div>
                <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Şirket</label>
                <input type="text" v-model="user.company" :disabled="!isEditing"
                    class="w-full p-2 border rounded focus:border-indigo-500 focus:ring bg-primary-bg dark:bg-gray-800" />
            </div>
        </div>

        <div v-if="isEditing" class="mt-6 text-right">
            <button @click="saveChanges"
                class="bg-primary-button hover:bg-primary-button-hover text-white px-6 py-2 text-sm rounded transition">Güncelle</button>
        </div>
    </div>


</template>

<script>
import { PencilSquareIcon, CameraIcon } from '@heroicons/vue/24/outline';

export default {
    name: 'ProfilPage',
    components: {
        PencilSquareIcon,
        CameraIcon,
    },
    data() {
        return {
            defaultImage: 'etik-uslu-logo.png',
            profileImage: null,
            isEditing: false,
            user: {
                name: 'OSMAN',
                surname: 'USLU',
                email: 'osmanuslu55',
                password: 'osmanuslu6566',
                phone: '0541 936 53 13',
                city: 'Samsun',
                district: 'Atakum',
                company: 'Multimedya Atölyesi',
                role: 'Admin'
            },
        };
    },
    methods: {
        toggleEdit() {
            this.isEditing = !this.isEditing;
        },
        imageChange(event) {
            const file = event.target.files[0];

            if (!file) {
                return;
            }

            if (!file.type.startsWith('image/')) {
                this.$toast && this.$toast.error("Lütfen bir resim dosyası seçin!");
                return;
            }

            if (file.size > 2 * 1024 * 1024) {
                this.$toast && this.$toast.error("Dosya boyutu 2MB'dan küçük olmalı!");
                return;
            }

            const reader = new FileReader();
            reader.onload = e => {
                this.profileImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveChanges() {
            this.isEditing = false;
            this.$toast && this.$toast.success("Profil güncellendi!");
        },
    },
};
</script>